export const initialState = {
  error: false,
  errorDetails: {
    code: null,
    message: null,
  },
  items: [],
  selected: {},
  loading: true,
}

const ManageUserInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_USERINFO_STATE':
      return initialState
    case 'SET_USERINFO_ITEMS':
      return {
        ...state,
        items: [...action.items],
        loading: false,
      }
    case 'SET_USERINFO_ERROR':
      return {
        ...state,
        error: action.error,
      }
    case 'SET_USERINFO_ERROR_DETAILS':
      return {
        ...state,
        errorDetails: action.errorDetails,
      }
    case 'SELECT_USERINFO_ITEM':
      return {
        ...state,
        selected: {
          [action.category]:
            state.selected[action.category] !== action.selected ? action.selected : null,
        },
      }
    case '@@wv/INVALIDATE_CACHE':
      return {
        ...state,
        selected: {},
        selectedDetails: null,
        selectedIndex: null,
      }
    default:
      return state
  }
}

export default ManageUserInfoReducer
